var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    { attrs: { content: "发送表情", placement: "top", effect: "light" } },
    [
      _c(
        "el-popover",
        {
          attrs: { placement: "bottom", width: "330" },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "ul",
            { staticClass: "emoji_list" },
            _vm._l(_vm.emojiList, function (item, index) {
              return _c("li", { key: index }, [
                _c("img", {
                  attrs: { src: item.img, alt: "" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerEmoji(index)
                    },
                  },
                }),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("img", {
            staticClass: "common_emoji",
            attrs: {
              slot: "reference",
              src: require("@/assets/tic/emoji.png"),
              alt: "",
            },
            slot: "reference",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/emoji.vue?vue&type=template&id=5a659e94&scoped=true&
// module id = null
// module chunks = 